import {
  Component,
  computed,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { SaveableTrackerService } from 'src/app/shared/services/saveable-tracker.service';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
  selector: '[app-topbar]',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    StyleClassModule,
    BreadcrumbComponent,
    InputTextModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    RippleModule,
    BadgeModule,
    OverlayBadgeModule,
    ButtonModule,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css',
})
export class TopbarComponent {
  readonly layoutService = inject(LayoutService);
  readonly currentSaveableSignal = inject(SaveableTrackerService).get();

  readonly isDarkTheme = computed(() => this.layoutService.isDarkTheme());
  readonly isButtonVisible = computed(() => !!this.currentSaveableSignal());
  readonly isDirty = computed(
    () => this.currentSaveableSignal()?.isDirty?.() ?? false
  );
  readonly isCancelButtonVisible = computed(
    () => this.currentSaveableSignal()?.isCancelVisible?.() ?? false
  );

  @ViewChild('menubutton') menuButton!: ElementRef;

  showRightMenu() {
    this.layoutService.toggleRightMenu();
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  toggleSearchBar() {
    this.layoutService.layoutState.update((value) => ({
      ...value,
      searchBarActive: !value.searchBarActive,
    }));
  }

  onSaveButtonClick() {
    this.currentSaveableSignal()?.save();
  }

  onCancelButtonClick() {
    this.currentSaveableSignal()?.cancel();
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }
}
